/**
 * radialBloom — pure radial zoom, fast outward flow, warm seed.
 *
 * Uses the `radial` warp kind (no rotation, no ripple). The motion is
 * driven entirely by zoom + audio modulation: bass pumps the zoom, treble
 * brightens the seed.
 */

import { WarpKind, type VisualizerPreset } from '../presetTypes';

export const radialBloomPreset: VisualizerPreset = {
  id: 'radialBloom',
  name: 'Radial Bloom',
  seed: {
    kind: 'waveform',
    params: {
      baseY: 0.0,
      gain: 0.4,
      halfThick: 0.014,
      intensity: 0.7,
      color: [1.0, 0.55, 0.2], // warm amber
      edgeSharp: 8.5,
    },
  },
  warp: {
    kind: WarpKind.Radial,
    params: {
      baseZoom: 0.018,
      bassZoomGain: 0.05,
      rotation: 0,
      bassRotationGain: 0,
      ripple: 0,
      rippleFreq: 0,
      decay: 0.975,
      chroma: 0.0035,
      hueShift: 0.018,
      beatPunch: 0.085,
      centerDriftAmp: 0.05,
      centerDriftRate: 0.13,
    },
  },
  modulation: [
    {
      target: 'warp.baseZoom',
      source: 'bass',
      transform: 'smoothPulse',
      amount: 0.025,
      smoothingMs: 80,
    },
    {
      target: 'seed.intensity',
      source: 'treble',
      transform: 'linear',
      amount: 0.5,
      smoothingMs: 60,
    },
    {
      target: 'warp.hueShift',
      source: 'beatConfidence',
      transform: 'smoothPulse',
      amount: 0.04,
      smoothingMs: 250,
    },
  ],
  transition: { durationMs: 900 },
};
